import { serverUrl, getheader } from "./CommonFunctions";
export function checkCardStatus(data, fn){
    return dispatch =>{
        dispatch({
            type:"Loading",
            data:true
        })
        fetch(serverUrl+"api/GuarantyAPI/GetGuarantyStatusData/?SerialNumber="+data.SerialNumber+"&GuarantyCode="+data.CardNo,{
            headers:getheader(),
            method:"GET",
            cache:"default"
        }).then(res=>res.json()).then(res=>{
            dispatch({
                type:"Loading",
                data:false
            })
            const array = [];
            if(!res.Message && Object.keys(res).length > 0)
            array.push(res);
            dispatch({
                type:"GET_CARD_STATUS",
                data:array
            })
            fn();
        }).catch(err=>err=>console.error('err',err));
    }
}
export function getCustomerCardList(fn){
    return dispatch =>{
        dispatch({
            type:"Loading",
            data:true
        })
        fetch(serverUrl+"api/GuarantyAPI/GetCustomerCardList/",{
            headers:getheader(),
            method:"GET",
            cache:"default"
        }).then(res=>res.json()).then(res=>{
            dispatch({
                type:"Loading",
                data:false
            })
            dispatch({
                type:"GET_CARD_STATUS",
                data:res
            })
            fn();
        }).catch(err=>err=>console.error('err',err));
    }
}
